import React, { useState } from "react";
import { Navigate, Route, Routes, useSearchParams } from "react-router-dom";
import StepOne from "./StepOne/StepOne";
import StepTwo from "./StepTwo/StepTwo";
import StepThree from "./StepThree/StepThree";
import HeaderSetAccount from "./Headers/HeaderSetAccount";
import { Container } from "./Styled";


const GetStarted = () => {
    const [email, setEmail] = useState('');
    const [fullName, setFullName]=useState('');
    const [userPassword, setUserPassword]= useState('');
    const [searchParams, setSearchParams] = useSearchParams();
    const [progress, setProgress] = useState('10')

    const verticalId = searchParams.get("vertical");
    const[verticalChoice, setVerticalChoice]=useState(verticalId);

    const updateVerticalChoice=(vertical: string) => {
        setVerticalChoice(vertical);
    }

    return (
        <div>
            <HeaderSetAccount progress={progress} />
            <Container>
                <Routes>
                    <Route path="/welcome" element={<StepOne email={email} setEmail={setEmail} fullName={fullName} setFullName={setFullName} setProgress={setProgress} />} />
                    <Route path="/verticals" element={<StepTwo chosenVertical={verticalChoice} updateVerticalChoice={updateVerticalChoice} setProgress={setProgress} />} />
                    <Route path="/password" element={<StepThree userPassword={userPassword} setUserPassword={setUserPassword} email={email} fullName={fullName} verticalChoice={verticalChoice} setProgress={setProgress} />} />
                    <Route path="*" element={<Navigate to="/self-service/welcome" />} />
                </Routes>
            </Container>
        </div>
    );
};

export default GetStarted;
